import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Container, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, HStack, IconButton, Link, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { MenuIcon } from 'lucide-react';
import { company, navLinks } from '../data/site';
export function Navbar() {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);
  return <Box as="header" position="sticky" top={0} zIndex={100} bg="rgba(255,255,255,0.92)" backdropFilter="saturate(180%) blur(8px)" borderBottom="1px solid" borderColor={scrolled ? 'navy.100' : 'transparent'} transition="border-color 200ms ease, box-shadow 200ms ease" boxShadow={scrolled ? '0 1px 2px rgba(13,20,29,0.04)' : 'none'} data-id="element-117" data-mp="1kzzq89z5dyfq">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} data-id="element-118" data-mp="olgrv9r4rclz">
        <Flex as="nav" aria-label="Main navigation" h={{
        base: '68px',
        md: '76px'
      }} align="center" justify="space-between" data-id="element-119" data-mp="okyto7kwqobf">
          <Link as={RouterLink} to="/" aria-label={`${company.wordmark} — home`} _hover={{
          textDecoration: 'none'
        }} data-id="element-120" data-mp="3s2grrnavogyn">
            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} fontWeight={600} letterSpacing="0.22em" color="navy.800" data-id="element-121" data-mp="u2v8rly4uv7">
              {company.wordmark}
            </Text>
          </Link>

          <HStack spacing={8} display={{
          base: 'none',
          lg: 'flex'
        }} data-id="element-122" data-mp="39b60h518q268">
            {navLinks.map(item => {
            const isActive = location.pathname === item.to;
            return <Link key={item.to} as={RouterLink} to={item.to} fontSize="sm" fontWeight={500} color={isActive ? 'navy.800' : 'navy.500'} pb={1} borderBottom="2px solid" borderColor={isActive ? 'accent.500' : 'transparent'} _hover={{
              color: 'navy.800',
              textDecoration: 'none',
              borderColor: 'accent.300'
            }} transition="color 150ms ease, border-color 150ms ease" data-id="element-123" data-mp="2wcyl07vtutkt">
                  {item.label}
                </Link>;
          })}
          </HStack>

          <HStack spacing={3} data-id="element-124" data-mp="7k441teyh840">
            <Button as={RouterLink} to="/contact" variant="solidNavy" size="md" display={{
            base: 'none',
            md: 'inline-flex'
          }} data-id="element-125" data-mp="7jb7tmdmi104">
              Contact Us
            </Button>
            <IconButton aria-label="Open menu" icon={<MenuIcon size={22} data-id="element-127" data-mp="f56nlbxaa95t" />} onClick={onOpen} variant="outlineNavy" display={{
            base: 'inline-flex',
            lg: 'none'
          }} h="44px" w="44px" minW="44px" data-id="element-126" data-mp="f3vj19w0kxdn" />
          </HStack>
        </Flex>
      </Container>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xs" data-id="element-128" data-mp="sw1zkx32x6dm">
        <DrawerOverlay data-id="element-129" data-mp="xt1tyaqkgkow" />
        <DrawerContent data-id="element-130" data-mp="xtlapo4hd31c">
          <DrawerCloseButton mt={2} data-id="element-131" data-mp="k2yeq3q3tr8y" />
          <DrawerHeader fontSize="md" fontWeight={600} letterSpacing="0.22em" color="navy.800" borderBottom="1px solid" borderColor="navy.100" data-id="element-132" data-mp="k1x2hvxcqypn">
            {company.wordmark}
          </DrawerHeader>
          <DrawerBody py={6} data-id="element-133" data-mp="1gle7ltmo78ec">
            <Stack as="nav" aria-label="Mobile navigation" spacing={1} data-id="element-134" data-mp="1glnxlh7ptfk1">
              {navLinks.map(item => <Link key={item.to} as={RouterLink} to={item.to} py={3} fontSize="md" fontWeight={500} color={location.pathname === item.to ? 'accent.600' : 'navy.700'} borderBottom="1px solid" borderColor="navy.50" _hover={{
              textDecoration: 'none',
              color: 'accent.600'
            }} data-id="element-135" data-mp="3p38gl4fwvy0r">
                  {item.label}
                </Link>)}
              <Button as={RouterLink} to="/contact" variant="solidNavy" size="md" mt={6} data-id="element-136" data-mp="1wzfnd0zniml">
                Contact Us
              </Button>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>;
}